import * as DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
    /**
     * Removed from default
     */
    // 'body',
    // 'button',
    // 'canvas',
    // 'footer',
    // 'form',
    // 'head',
    // 'header',
    // 'html',
    // 'input',
    // 'select',
    // 'optgroup',
    // 'option',
    // 'style',
    // 'textarea',

    /**
     * Default tags
     */
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'br',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hgroup',
    'hr',
    'i',
    'img',
    'ins',
    'j-mention',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'shadow',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',

    /**
     * Custom
     */
    'iframe', // Embedded contents ; ex : YouTube
];

export const ALLOWED_ATTR = [
    /**
     * Removed from default
     */
    // 'action',
    // 'color',
    // 'background',
    // 'bgcolor',
    // 'xmlns',
    // 'align',
    // 'valign',

    /**
     * Default attributes
     */
    'accept',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'playsinline',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'target',
    'title',
    'translate',
    'type',
    'usemap',
    'value',
    'width',
    'slot',

    /**
     * Custom (iframe)
     */
    'allowfullscreen',
    'frameborder',
];

/**
 * ⚠️ Update is needed in jamespot-pro (JPUtils.php::initPurifier)
 */
const ALLOWED_STYLE_PROPERTIES = [
    'background-color',
    'border',
    'border-collapse',
    'border-color',
    'border-bottom-color',
    'border-left-color',
    'border-right-color',
    'border-top-color',
    'border-spacing',
    'border-radius',
    'border-width',
    'color',
    'display',
    'font-size',
    'height',
    'line-height',
    'list-style-type',
    'margin',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'padding',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'text-align',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-style',
    'text-decoration-thickness',
    'vertical-align',
    'width',
];

// const ALLOWED_IFRAME_DOMAINS = [
//     'youtube.com',
//     'youtu.be',
//     'vimeo.com',
//     'dailymotion.com',
//     'twitch.tv',
//     'twitter.com',
//     'facebook.com',
//     'instagram.com',
//     'tiktok.com',
//     'likedin.com',
//     'reddit.com',
//     'loom.com',
//     'lemonde.fr',
//     'lefigaro.fr',
//     'liberation.fr',
//     'francetvinfo.fr',
//     'bfmtv.com',
//     'tf1.fr',
//     '20minutes.fr',
//     'ouest-france.fr',
// ];

DOMPurify.addHook('afterSanitizeAttributes', (currentNode) => {
    if (currentNode.tagName.toLowerCase() === 'iframe') {
        // TODO : Restreindre les iframes à des domaines domaines whitelistés
        //  -> Whitelist par défaut +  possibilité de paramétrage de la liste par l'admin de la plateforme.
        // const src = currentNode.getAttribute('src');
        // try {
        //     if (src) {
        //         if (!ALLOWED_IFRAME_DOMAINS.includes(new URL(src).host)) {
        //             currentNode.insertAdjacentHTML('afterend', '<p>iframe :: Not allowed domain</p>');
        //             currentNode.remove();
        //         } else {
        //             currentNode.setAttribute('sandbox', 'allow-scripts allow-same-origin');
        //         }
        //     }
        // } catch (e) {
        //     currentNode.insertAdjacentHTML('afterend', '<p>iframe :: Invalid URL</p>');
        //     currentNode.remove();
        // }
        currentNode.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    }
    // Sanitize Styles
    if ('style' in currentNode) {
        const output = validateStyles(currentNode.style as CSSStyleDeclaration);
        if (output.length) {
            currentNode.setAttribute('style', output.join(''));
        } else {
            currentNode.removeAttribute('style');
        }
    }
});

export function sanitizeHtml(dirtyHtml?: string) {
    return DOMPurify.sanitize(dirtyHtml || '', {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
    });
}

export function validateStyles(styles: CSSStyleDeclaration): string[] {
    const output: string[] = [];
    Object.keys(styles).forEach(function (key) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const valueKey = styles[key];
        if (typeof valueKey !== 'string') return;

        const normalizedKey = valueKey.replace(/([A-Z])/g, '-$1').toLowerCase();
        if (ALLOWED_STYLE_PROPERTIES.includes(normalizedKey)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            const value = styles[normalizedKey];
            output.push(`${normalizedKey}:${value};`);
        }
    });
    return output;
}

export const htmlDecodeSpecialChars = (str: string) => {
    return (
        new DOMParser().parseFromString(str.replace(/</g, '___E_S_C_A_P_E_D___'), 'text/html').documentElement
            .textContent ?? ''
    ).replace(/___E_S_C_A_P_E_D___/g, '<');
};
